"use client";

import {type JSX, type ReactNode, useEffect, useState} from "react";

interface ClientOnlyProps {
    children: ReactNode;
}

/**
 * Renders children only on the client after hydration.
 * Prevents hydration mismatches for content that differs between server and client.
 */
export function ClientOnly({children}: ClientOnlyProps): JSX.Element | null {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) return null;

    return <>{children}</>;
}
